import TermsOfUsage from "../../../components/Terms/TermsOfUsage";

const TermsOfUsagePage = () => {
    return (
        <TermsOfUsage></TermsOfUsage>
    );
}

export default TermsOfUsagePage;
